import { useTheme } from "@mui/material/styles";

import Icon from "ui/atom/Icon";
import Image from "ui/atom/Image";
import Button from "ui/base/Button";
import Card from "ui/base/Card";
import Page from "ui/Page";

import { useContent } from "../fabric";


export default function Content() {
	const { query, featured, form } = useContent();
	const theme = useTheme();

	const style = {
		card: {
			position: "relative"
		},
		form: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(1)
		},
		featured: {
			position: "absolute",
			top: 10,
			right: 10
		}
	} as StyleProps;

	return (
		<Page maxWidth="sm">
			<Page.Body>
				<Card sx={style.card}>
					<Card.Header
						title={`Content #${query.data.id}`}
						action={
							<Button.Icon icon="star" fill={query.data?.featured ? theme.palette.coin.main : ""} onClick={() => featured.mutate({ id: query.data.id, value: !query.data.featured })} />
						}
					/>
					<Card.Content>
						<Image.Cover src={query.data?.thumbUrl} size={150} sx={{ mx: "auto" }} />
						<form style={style.form}>
							<form.AppForm>
								<form.AppField name="title" children={(field) => <field.Input label="Title" required />} />
								<form.AppField name="description" children={(field) => <field.Input label="Description" multiline rows={3} />} />
								<form.AppField name="publishedOn" children={(field) => <field.Date label="Published On" required />} />
								<form.AppField name="url" children={(field) => <field.Input label="Url" required />} />
								<form.AppField name="tokens" children={(field) => <field.Input label="Tokens" startAdornment={<Icon name="coin" />} required />} />
								<form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
									{([canSubmit, isSubmitting]) => {
										return (
											<Button variant="contained" color="success" disabled={!canSubmit} loading={isSubmitting} onClick={form.handleSubmit} sx={{ ml: "auto" }}>
												Save
											</Button>
										);
									}}
								</form.Subscribe>
							</form.AppForm>
						</form>
					</Card.Content>
				</Card>
			</Page.Body>
		</Page>
	);
}